import { Routes } from '@angular/router';
import { Shell } from './layout/shell/shell';
import { ProjectsPage } from './pages/projects/projects-page';
import { ProjectDetailPage } from './pages/project-detail/project-detail-page';
import { PlaceholderPage } from './pages/placeholder/placeholder-page';
import { LoginPage } from './pages/login/login-page';
import { AuthBridgePage } from './pages/auth-bridge/auth-bridge-page';
import { AuthCallbackPage } from './pages/auth-callback/auth-callback-page';
import { authGuard } from './core/auth.guard';
import { AUTH_BRIDGE_PATH } from './core/auth-bridge-route';

export const routes: Routes = [
  // Public login route, outside the guarded shell: it hands off to the org auth
  // library's Auth0 Lock widget (a redirect flow).
  {
    path: 'login',
    component: LoginPage,
    title: 'Sign in',
  },
  // The app root, and Auth0's redirect target. MUST stay unguarded and MUST stay
  // ahead of the shell route below: Auth0 returns here with the tokens in the URL
  // fragment, and only a route that actually activates preserves that fragment
  // long enough for Lock to read it. `pathMatch: 'full'` confines this to the
  // exact empty path, so the shell still owns /projects, /home and the rest.
  // See pages/auth-callback/auth-callback-page.ts.
  {
    path: '',
    pathMatch: 'full',
    component: AuthCallbackPage,
  },
  // TEMPORARY: headless iframe endpoint that posts the Auth0 token to a trusted
  // parent site. Public + unguarded so it can report `failed` when signed out.
  {
    path: AUTH_BRIDGE_PATH,
    component: AuthBridgePage,
  },
  {
    path: '',
    component: Shell,
    canActivate: [authGuard],
    children: [
      {
        path: 'projects',
        component: ProjectsPage,
        title: 'Feedback and Review Projects | Brafton',
        data: { breadcrumbs: ['Projects'] },
      },
      {
        path: 'projects/:id',
        component: ProjectDetailPage,
        title: 'Feedback and Review Projects | Brafton',
        data: { breadcrumbs: ['Projects', 'Detail'] },
      },
      {
        path: 'home',
        component: PlaceholderPage,
        title: 'Feedback And Review | Brafton',
        data: { title: 'Home', breadcrumbs: ['Home'] },
      },
      {
        path: 'tasks',
        component: PlaceholderPage,
        title: 'My Tasks',
        data: { title: 'My Tasks', breadcrumbs: ['My Tasks'] },
      },
      {
        path: 'calendar',
        component: PlaceholderPage,
        title: 'My Calendar',
        data: { title: 'My Calendar', breadcrumbs: ['My Calendar'] },
      },
      {
        path: 'kanban',
        component: PlaceholderPage,
        title: 'My Kanban',
        data: { title: 'My Kanban', breadcrumbs: ['My Kanban'] },
      },
      {
        path: 'team-tasks',
        component: PlaceholderPage,
        title: 'Team Tasks',
        data: { title: 'Team Tasks', breadcrumbs: ['My Team', 'Tasks'] },
      },
      {
        path: 'organizations',
        component: PlaceholderPage,
        title: 'Organizations',
        data: { title: 'Organizations', breadcrumbs: ['Organizations'] },
      },
      {
        path: 'content',
        component: PlaceholderPage,
        title: 'Content',
        data: { title: 'Content', breadcrumbs: ['Content'] },
      },
      {
        path: 'saved',
        component: PlaceholderPage,
        title: 'Saved',
        data: { title: 'Saved', breadcrumbs: ['Saved'] },
      },
    ],
  },
  // '/' is handled by AuthCallbackPage above, which forwards to /projects (or
  // /login) once it has ruled out an in-flight Auth0 callback.
  { path: '**', redirectTo: '' },
];
